import React from "react";
import { Link } from "react-router-dom";

// Product card for a shipped piece of work. The visual adapts to what the
// project actually is — a phone app, a web build, or server-side work that
// has no interface to show.
const AppCard = ({ project }) => {
  const {
    id,
    name,
    tagline,
    img,
    category,
    platforms = [],
    type = "app",
    client,
    clientConfidential,
  } = project;

  return (
    <Link
      to={`/projects/${id}`}
      className="group flex flex-col bg-ink-card border border-ink-line rounded-tile
                 overflow-hidden transition-all duration-300
                 hover:border-brand/50 hover:-translate-y-1 hover:shadow-card"
    >
      <div className="relative h-56 overflow-hidden bg-gradient-to-br from-[#161626] to-[#0D0D18] flex items-end justify-center">
        {/* brand glow behind the artwork */}
        <div className="pointer-events-none absolute -bottom-20 left-1/2 -translate-x-1/2 w-72 h-72 rounded-full bg-brand/20 blur-[70px]" />

        <span className="absolute top-3 left-3 z-10 font-mono text-[10px] tracking-[0.22em] uppercase
                         text-brand-cyan bg-ink/70 border border-ink-line backdrop-blur-sm
                         rounded-full px-3 py-1">
          {category}
        </span>

        {type === "app" && (
          <img
            src={img}
            alt={name}
            loading="lazy"
            className="relative h-[86%] w-auto object-contain object-top rounded-t-2xl
                       shadow-[0_10px_36px_rgba(0,0,0,0.65)]
                       transition-transform duration-500 group-hover:scale-[1.04]"
          />
        )}

        {type === "web" && (
          <img
            src={img}
            alt={name}
            loading="lazy"
            className="relative w-[86%] h-auto object-cover object-top rounded-t-xl
                       shadow-[0_10px_36px_rgba(0,0,0,0.65)]
                       transition-transform duration-500 group-hover:scale-[1.04]"
          />
        )}

        {type === "backend" && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
            <svg
              width="54"
              height="54"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#19D0E0"
              strokeWidth="1.3"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="2" y="3" width="20" height="6" rx="1.5" />
              <rect x="2" y="15" width="20" height="6" rx="1.5" />
              <path d="M6 6h.01M6 18h.01" />
              <path d="M12 9v6" />
            </svg>
            <span className="font-mono text-[10px] tracking-[0.22em] text-muted">
              SERVER-SIDE MODULE
            </span>
          </div>
        )}
      </div>

      <div className="flex flex-col flex-1 gap-2.5 p-6">
        {(client || clientConfidential) && (
          <p className="font-mono text-[10px] tracking-[0.2em] text-brand-cyan">
            {client ? `FOR ${client.toUpperCase()}` : "CLIENT PROJECT"}
          </p>
        )}
        <h3 className="font-display text-[26px] leading-none tracking-wide text-paper
                       group-hover:text-brand-cyan transition-colors">
          {name}
        </h3>
        <p className="text-sm text-muted leading-relaxed flex-1">{tagline}</p>

        <div className="flex items-center justify-between pt-4 mt-1 border-t border-ink-line">
          <div className="flex gap-2">
            {platforms.length > 0 ? (
              platforms.map((p) => (
                <span
                  key={p}
                  className="font-mono text-[10px] tracking-wider text-muted
                             border border-ink-line rounded-full px-2.5 py-1"
                >
                  {p}
                </span>
              ))
            ) : (
              <span className="font-mono text-[10px] tracking-wider text-muted">
                COMING SOON
              </span>
            )}
          </div>
          <span className="text-sm font-medium text-brand-cyan opacity-0 -translate-x-1
                           group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
            View →
          </span>
        </div>
      </div>
    </Link>
  );
};

export default AppCard;
